import myPlug from '@/commons/my-plug'

export default {
    namespaced: false, // 不使用命名空间，如果使用请在调用的地方使用路径如：app/GET_USERINFO
    state: {
        boxDetail: null,
        boxDetailRerefsh: ""
    },
    mutations: {
        boxDetail(state, res) {
            //   boxDetail有3种可能，所以3个属性去控制 this.$store.commit('boxDetail', { data: res.data[0] })
            //data是列表  carList是4个卡片  oneCardInfo是一个卡片
            if (res && res.sort) {
                res.sourceData = JSON.parse(JSON.stringify(res.data))
                res.data = myPlug.sortName2cn(res.data, res.sort);
            }
            state.boxDetail = res
        },
        boxDetailRerefsh(state, data) {
            state.boxDetailRerefsh = data
        }
    },
    actions: {
        // ACT_SET_DICTIONARY({
        //     commit,
        //     state
        // }) {
        //     commit('SET_DICTIONARY', JSON.parse(sessionStorage.dictionary))
        // }
    }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/detail.js